/**
 * TIDAL: scroll infinito limitado + botón "Ver más alfombras".
 * Carga automáticamente TIDAL_AUTO_PAGES tandas al hacer scroll; después pausa el
 * scroll infinito y muestra el botón. Al pulsarlo se carga una tanda más y se
 * reactiva el scroll automático durante otras TIDAL_AUTO_PAGES tandas.
 */
(function () {
  var AUTO_PAGES = 2;

  customElements.whenDefined('custom-pagination').then(function () {
    var proto = customElements.get('custom-pagination').prototype;
    var origLoadMore = proto.loadMore;

    // El clic en el botón reactiva la carga (en fase de captura, antes del manejador del tema,
    // que ya quedó enlazado al método original al conectarse el elemento).
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('.js-pagination-load-more');
      if (!btn) return;
      var cp = btn.closest('custom-pagination');
      if (!cp) return;
      cp.tidalAuto = 0;
      cp.dataset.pauseInfiniteScroll = 'false';
      cp.classList.remove('is-paused');
    }, true);

    proto.loadMore = async function () {
      if (this.dataset.infiniteScroll !== 'true') return origLoadMore.call(this);
      if (this.dataset.pauseInfiniteScroll === 'true') return undefined;
      var before = this.results ? this.results.length : 0;
      var nextUrl = this.loadMoreButton ? this.loadMoreButton.href : null;
      var result = await origLoadMore.call(this);
      var after = this.results ? this.results.length : 0;
      if (after > before) {
        // SEO/UX: la URL refleja la página cargada (?page=2, ?page=3...)
        if (nextUrl && window.history && window.history.replaceState) {
          try { window.history.replaceState(window.history.state, '', nextUrl); } catch (e) { /* ignorar */ }
        }
        this.tidalAuto = (this.tidalAuto || 0) + 1;
        if (this.tidalAuto >= AUTO_PAGES) {
          this.dataset.pauseInfiniteScroll = 'true';
          this.classList.add('is-paused');
        }
      }
      return result;
    };
  });
})();
